import type { Customer } from "@gasparigit/omnia-sdk";

export function remainQuestionString(customer: Customer) {
  if (customer.calculated_remain_questions < 0) return null;

  return `${customer.calculated_remain_questions} quesiti rimanenti`;
}
